export enum ÉtatActivité {
  EN_COURS = 'EnCours',
  TERMINEE = 'Terminee',
}
